module.exports = __webpack_public_path__ + "img/hp7.77ba82d6.png";